import { gqlClient } from 'gql'
import { produce } from 'immer'
import lodash from 'lodash'

import type { SectionTreeItemType } from 'components/sections/ProjectStructure/utils'
import type {
  EmployeePreferencesSchemaFragment,
  ProjectSchemaFragment,
  SectionOrderSchemaFragment,
} from 'gql/__generated__/graphql'
import { sectionsAllQuery } from 'gql/sections/gql/queries'

import { projectFragment } from './gql/fragments'

export const projectModifySectionsOrder = (
  projectId: string,
  sectionsOrder?: SectionOrderSchemaFragment[] | null,
) => {
  const cache = gqlClient.core.cache
  try {
    cache.modify({
      id: 'Project:' + projectId,
      fields: {
        sectionsOrder: () => {
          return sectionsOrder || null
        },
      },
    })
  } catch (err) {
    console.error('"projectModifySectionsOrder" fn is crashed on operation: ".modify"', err)
  }
}

export const projectModifyEmployeePreference = (
  projectId: string,
  employeePreferences?: Omit<EmployeePreferencesSchemaFragment, '__typename'> | null,
) => {
  if (!employeePreferences) {
    return
  }

  const cache = gqlClient.core.cache

  try {
    const existing = cache.readFragment<ProjectSchemaFragment>({
      id: `Project:${projectId}`,
      fragment: projectFragment,
      fragmentName: 'ProjectSchema',
    })

    if (!existing) {
      return
    }

    cache.writeFragment({
      id: `Project:${projectId}`,
      fragment: projectFragment,
      fragmentName: 'ProjectSchema',
      data: produce(existing, (draft) => {
        const merged = lodash.merge({}, existing?.employeePreferences, employeePreferences)
        draft.employeePreferences = merged
      }),
    })
  } catch (err) {
    console.error('"projectModifyEmployeePreference" fn is crashed on operation: ".modify"', err)
  }
}

export const updateSectionsAndSectionOrderInCache = (
  projectId: string,
  sections: SectionTreeItemType[],
  sectionOrder: SectionOrderSchemaFragment[] | null,
) => {
  projectModifySectionsOrder(projectId, sectionOrder)
  const cache = gqlClient.core.cache
  try {
    const data = cache.readQuery({
      query: sectionsAllQuery,
      variables: {
        projectId,
      },
    })

    if (data) {
      cache.writeQuery({
        query: sectionsAllQuery,
        variables: {
          projectId,
        },
        data: produce(data, (draft) => {
          draft.data.sections = [...sections]
        }),
      })
    }
  } catch (err) {
    console.error('"addEmployee" fn is crashed on operation: ".writeQuery"', err)
  }
}
